import script from "./VendorList.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorList.vue?vue&type=script&setup=true&lang=js"

import "./VendorList.vue?vue&type=style&index=0&id=d4487ace&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4487ace"]])

export default __exports__